import BlockIcon from "@mui/icons-material/Block";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import HeartBrokenIcon from "@mui/icons-material/HeartBroken";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import page6_section6 from "../../../assets/images/AboutVedaz/page6_section6.jpg";
import page8_section1 from "../../../assets/images/AboutVedaz/page8_section1.jpg";
import page8_section3 from "../../../assets/images/AboutVedaz/page8_section3.jpg";
import page8_section5 from "../../../assets/images/AboutVedaz/page8_section5.jpg";
import classes from "../AboutVedaz.styles";
import { ColorBanner } from "./CompatComponents";

interface Props {
  chapterIndex: number;
}

const GeneticAspect = ({ chapterIndex }: Props) => {
  const { t } = useTranslation();

  return (
    <Box>
      {/* ── Section 1: Background image ───────────────────────────── */}
      <Box sx={classes.bgSection}>
        <Box
          component="img"
          src={page8_section1}
          alt=""
          sx={classes.bgSectionMedia}
        />
        <Box sx={classes.bgSectionOverlay} />
        <Box sx={classes.bgSectionContent}>
          <Typography sx={classes.sectionHeading}>
            {t("about_genetic_heading")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, maxWidth: "420px" }}>
            {t("about_genetic_s1_body1")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, maxWidth: "420px", mb: 0 }}>
            {t("about_genetic_s1_body2")}
          </Typography>
        </Box>
      </Box>

      {/* ── Section 2: Red — plain section ───────────────────────── */}
      <Box sx={classes.plainSection}>
        <ColorBanner
          colorKey="red"
          Icon={BlockIcon}
          header={t("about_genetic_red_header")}
          subtitle={t("about_genetic_red_subtitle")}
        />
        <Typography sx={{ ...classes.bodyText, mb: 0 }}>
          {t("about_genetic_red_body")}
        </Typography>
      </Box>

      {/* ── Section 3: Yellow — background image ─────────────────── */}
      <Box sx={classes.bgSection}>
        <Box
          component="img"
          src={page8_section3}
          alt=""
          sx={classes.bgSectionMedia}
        />
        <Box sx={classes.bgSectionOverlay} />
        <Box sx={classes.bgSectionContent}>
          <ColorBanner
            colorKey="yellow"
            Icon={HeartBrokenIcon}
            header={t("about_genetic_yellow_header")}
            subtitle={t("about_genetic_yellow_subtitle")}
          />
          <Typography sx={{ ...classes.bodyText, maxWidth: "420px" }}>
            {t("about_genetic_yellow_body1")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, maxWidth: "420px" }}>
            {t("about_genetic_yellow_body2")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, maxWidth: "420px", mb: 0 }}>
            {t("about_genetic_yellow_body3")}
          </Typography>
        </Box>
      </Box>

      {/* ── Section 4: Light Green — image right, content left ────── */}
      <Box sx={classes.sideRow}>
        <Box sx={classes.sideContent}>
          <ColorBanner
            colorKey="lightGreen"
            Icon={FavoriteBorderIcon}
            header={t("about_genetic_lightGreen_header")}
            subtitle={t("about_genetic_lightGreen_subtitle")}
          />
          <Typography sx={classes.bodyText}>
            {t("about_genetic_lightGreen_body1")}
          </Typography>
          <Typography sx={classes.bodyText}>
            {t("about_genetic_lightGreen_body2")}
          </Typography>
          <Typography sx={classes.bodyText}>
            {t("about_genetic_lightGreen_body3")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, mb: 0 }}>
            {t("about_genetic_lightGreen_body4")}
          </Typography>
        </Box>
        <Box sx={classes.sideImage}>
          <img src={page6_section6} alt={t("about_genetic_lightGreen_header")} />
        </Box>
      </Box>

      {/* ── Section 5: Dark Green — background image ─────────────── */}
      <Box sx={classes.bgSection}>
        <Box
          component="img"
          src={page8_section5}
          alt=""
          sx={classes.bgSectionMedia}
        />
        <Box sx={classes.bgSectionOverlay} />
        <Box sx={classes.bgSectionContent}>
          <ColorBanner
            colorKey="darkGreen"
            Icon={FavoriteIcon}
            header={t("about_genetic_darkGreen_header")}
            subtitle={t("about_genetic_darkGreen_subtitle")}
          />
          <Typography sx={{ ...classes.bodyText, maxWidth: "420px" }}>
            {t("about_genetic_darkGreen_body1")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, maxWidth: "420px" }}>
            {t("about_genetic_darkGreen_body2")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, maxWidth: "420px" }}>
            {t("about_genetic_darkGreen_body3")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, maxWidth: "420px", mb: 0 }}>
            {t("about_genetic_darkGreen_body4")}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default GeneticAspect;
